<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div
        class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent"
    >
      <h5 v-show="isContactInfoEditable" class="card-title text-muted m-0">
        {{ $t("contact_info") }}
      </h5>
      <h5 v-show="!isContactInfoEditable" class="card-title text-muted m-0">
        {{ $t("edit_contact_info") }}
      </h5>
      <div>
        <a
            href="#"
            v-show="!isContactInfoEditable"
            class="text-muted"
            @click.prevent="showContactInfoHide"
        >
          <app-icon stroke-width="1" name="x-square"/>
        </a>
        <template v-if="personId != null">
          <a
              href="#"
              v-show="!isContactInfoEditable"
              class="text-muted"
              @click.prevent="showContactInfoSave"
          >
            <app-icon stroke-width="1" name="check-square"/>
          </a>
        </template>
        <template v-if="dealStatus">
          <a
              href="#"
              v-if="personId != null"
              v-show="isContactInfoEditable"
              class="text-muted"
              @click.prevent="showContactInfoEditable"
          >
            <app-icon stroke-width="1" name="edit"/>
          </a>
          <a
              href="#"
              v-else
              v-show="isContactInfoEditable"
              class="text-muted"
              @click.prevent=""
          >
            <app-icon stroke-width="1" name="edit"/>
          </a>
        </template>
      </div>
    </div>
    <div class="card-body">
      <template v-if="personId != null">
        <div v-show="isContactInfoEditable">
          <div class="form-group">
            <div class="form-row">
              <label class="text-muted col-12">
                <template v-if="contactInfo && contactInfo.phone.length">
                  <span v-if="contactInfo.phone.length > 1">{{
                      $t("phones")
                    }}</span>
                  <span v-else>{{ $t("phone") }}</span>
                </template>
                <template v-else>
                  <span>{{ $t("no_phone_number_added") }}</span>
                </template>
              </label>
              <div class="col-12" v-if="contactInfo && contactInfo.phone">
                <div
                    class="d-flex justify-content-between"
                    v-for="(phoneNumber, index) in contactInfo.phone"
                    :key="index"
                >
                  <div>{{ phoneNumber.value }}</div>

                  <div
                      :class="{
                      'mb-2':
                        contactInfo &&
                        contactInfo.phone.length > 1 &&
                        index !== contactInfo.phone.length - 1,
                    }"
                  >
                    <span v-if="phoneNumber.type">
                      <app-badge
                          v-if="phoneNumber.type.class"
                          :label="phoneNumber.type.name"
                          :class-name="`badge-sm badge-pill badge-${phoneNumber.type.class}`"
                      />
                      <app-badge
                          v-else
                          :label="phoneNumber.type.name"
                          :class-name="`badge-sm badge-pill badge-secondary`"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-0">
            <div class="form-row">
              <label class="text-muted col-12">
                <template v-if="contactInfo && contactInfo.email.length">
                  <span v-if="contactInfo.email.length > 1">{{
                      $t("emails")
                    }}</span>
                  <span v-else>{{ $t("email") }}</span>
                </template>
                <template v-else>
                  <span>{{ $t("no_email_added") }}</span>
                </template>
              </label>
              <div class="col-12" v-if="contactInfo && contactInfo.email">
                <div
                    class="d-flex justify-content-between"
                    v-for="(email, index) in contactInfo.email"
                    :key="index"
                >
                  <div class="text-break">{{ email.value }}</div>

                  <div
                      :class="{
                      'mb-2':
                        contactInfo.email.length > 1 &&
                        index !== contactInfo.email.length - 1,
                    }"
                  >
                    <span v-if="email.type">
                      <app-badge
                          v-if="email.type.class"
                          :label="email.type.name"
                          :class-name="`badge-sm badge-pill badge-${email.type.class}`"
                      />
                      <app-badge
                          v-else
                          :label="email.type.name"
                          :class-name="`badge-sm badge-pill badge-secondary`"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!isContactInfoEditable">
          <div class="form-group">
            <div class="form-row">
              <label
                  class="col-12"
                  v-if="contactInfo && contactInfo.phone.length > 1"
              >
                {{ $t("phones") }}</label
              >
              <label class="col-12" v-else>{{ $t("phone") }}</label>

              <div class="col-12" v-if="contactInfo && contactInfo.phone">
                <div
                    v-for="(phoneNumber, index) in contactInfo.phone"
                    :key="index"
                    :class="{
                    'mb-3':
                      contactInfo.phone.length > 1 &&
                      index !== contactInfo.phone.length - 1,
                  }"
                >
                  <div class="form-row">
                    <div class="col-12 mb-1">
                      <app-input
                          type="tel-input"
                          v-model="phoneNumber.value"
                          :placeholder="$t('enter_phone')"
                          :required="true"
                      />
                      <small class="text-danger" v-if="errors['phone.'+index+'.value']">{{errors['phone.'+index+'.value'][0]}}</small>
                    </div>
                    <div class="col-10">
                      <app-input
                          type="select"
                          list-value-field="name"
                          :list="typeList"
                          :placeholder="$t('type')"
                          v-model="phoneNumber.type_id"
                      />
                    </div>

                    <div
                        class="col-2 d-flex justify-content-center align-items-center"
                    >
                      <a
                          href="#"
                          class="text-muted"
                          @click.prevent="deleteContactInfo('phone', index)"
                      >
                        <app-icon width="20" stroke-width="1" name="trash"/>
                      </a>
                    </div>
                  </div>
                </div>
                <a
                    href="#"
                    class="font-size-90"
                    @click.prevent="addMoreContactInfo('phone')"
                >
                  {{ $t("add_more") }}
                </a>
              </div>
            </div>
          </div>
          <div class="form-group mb-0">
            <div class="form-row">
              <label class="col-12" v-if="contactInfo && contactInfo.email.length > 1">
                {{ $t("emails") }}
              </label>
              <label class="col-12" v-else>{{ $t("email") }}</label>
              <div class="col-12" v-if="contactInfo && contactInfo.email">
                <div
                    v-for="(email, index) in contactInfo.email"
                    :key="index"
                    :class="{
                    'mb-3':
                      contactInfo.email.length > 1 &&
                      index !== contactInfo.email.length - 1,
                  }"
                >
                  <div class="form-row">
                    <div class="col-12 mb-1">
                      <app-input
                          type="text"
                          v-model="email.value"
                          :placeholder="$t('enter_email')"
                      />
                      <small class="text-danger" v-if="errors['email.'+index+'.value']">
                        {{ generateValidationMessage(errors['email.' + index + '.value'][0], 'email') }}
                      </small>
                    </div>
                    <div class="col-10">
                      <app-input
                          type="select"
                          list-value-field="name"
                          :list="typeList"
                          :placeholder="$t('type')"
                          v-model="email.type_id"
                      />
                    </div>

                    <div
                        class="col-2 d-flex justify-content-center align-items-center"
                    >
                      <a
                          href="#"
                          class="text-muted"
                          @click.prevent="deleteContactInfo('email', index)"
                      >
                        <app-icon width="20" stroke-width="1" name="trash"/>
                      </a>
                    </div>
                  </div>
                </div>
                <a
                    href="#"
                    class="font-size-90"
                    @click.prevent="addMoreContactInfo('email')"
                >
                  {{ $t("add_more") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="text-muted">{{ $t("not_added_yet") }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";

export default {
  name: "DealContactInfo",
  props: ["contactInfo", "personId", "contactInfoDetails"],
  mixins: [FormMixin],

  data() {
    return {
      isContactInfoEditable: true,
      errors: {}
    };
  },
  computed: {
    typeList() {
      return this.$store.getters.getPhoneEmailType;
    },
    dealStatus() {
      return (
          this.contactInfoDetails.status.name == "status_open" &&
          this.contactInfoDetails.status.type == "deal"
      );
    },
  },
  methods: {
    generateValidationMessage(value, name) {
      let message = value.split(" ");
      message[1] = name;
      return message.join(' ');
    },
    addMoreContactInfo(type) {
      if (type === "phone") {
        this.contactInfo.phone.push({
          phone: {
            value: "",
            type_id: "",
          },
        });
      } else {
        this.contactInfo.email.push({
          email: {
            value: "",
            type_id: "",
          },
        });
      }
    },

    showContactInfoHide() {
      this.isContactInfoEditable = true;
    },
    showContactInfoEditable() {
      this.isContactInfoEditable = false;
    },

    showContactInfoSave() {
      let PhoneFlatArray = this.contactInfo.phone.map((data) => {
        return {
          value: data.value,
          type_id: data.type_id,
        };
      });

      let EmailFlatArray = this.contactInfo.email.map((data) =>{
        return {
          value: data.value,
          type_id: data.type_id,
        };
      });
      this.submitFromFixin('post', `crm/persons/contact/sync/${this.personId}`, {phone: PhoneFlatArray, email: EmailFlatArray})
    },
    afterError(response){
      this.errors = response.data.errors;
    },
    afterSuccess(response){
      this.$toastr.s(response.data.message);
      this.isContactInfoEditable = true;
      this.$emit("update-deal");
    },
    deleteContactInfo(type, index) {
      if (type === "phone") {
        this.contactInfo.phone.splice(index, 1);
      } else {
        this.contactInfo.email.splice(index, 1);
      }
    },
  },
  mounted() {
    this.$store.dispatch("getPhoneEmailType");
  },
};
</script>

